module.exports = __webpack_public_path__ + "static/media/lock.007f86d7.svg";